(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nq-community"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('.nq-cmty'); if (!root) return;
    var vids = [].slice.call(root.querySelectorAll('video'));
    (function(){if(window.nqVidQ)return;var Q0=[],Q1=[],active=0,MAX=4;function pick(){return Q0.length?Q0.shift():Q1.shift();}function next(){while(active<MAX&&(Q0.length||Q1.length)){var v=pick();if(!v||v.dataset.q==='done'||v.dataset.q==='loading')continue;if(v.readyState>=2){v.dataset.q='done';continue;}active++;v.dataset.q='loading';var done=false;var fin=function(){if(done)return;done=true;active--;v.dataset.q='done';v.removeEventListener('canplay',fin);v.removeEventListener('error',fin);next();};v.addEventListener('canplay',fin);v.addEventListener('error',fin);setTimeout(fin,5000);v.preload='auto';if(v.readyState<1&&v.paused){try{v.load();}catch(_){}}}}window.nqVidQ={state:function(){return {q0:Q0.length,q1:Q1.length,active:active};},add:function(vs,tier){vs=[].slice.call(vs).filter(function(v){return v.dataset.q!=='done'&&v.dataset.q!=='loading';});vs.forEach(function(v){var i=Q0.indexOf(v);if(i>-1)Q0.splice(i,1);i=Q1.indexOf(v);if(i>-1)Q1.splice(i,1);});if(tier<0)Q0=vs.concat(Q0);else if(tier===0)Q0=Q0.concat(vs);else Q1=Q1.concat(vs);next();}};})();
    function nqNear(scroller,vs){var r=scroller.getBoundingClientRect();var out=[];vs.forEach(function(v){var b=v.getBoundingClientRect();if(b.right>r.left-300&&b.left<r.right+900)out.push(v);});return out;}
    var vp0 = root.querySelector('.nq-cmty__viewport');
    var first = vids.filter(function (v) { return !v.parentElement.closest('[aria-hidden]'); });
    var nqStarted = false; function nqStart() { if (nqStarted) return; nqStarted = true; nqVidQ.add(nqNear(vp0, vids), 0); }
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (es) { if (es[0].isIntersecting) nqStart(); }, { rootMargin: '300px 0px', threshold: 0 }).observe(root); } else { nqStart(); }
    var hs = null; vp0.addEventListener('scroll', function () { if (hs) return; hs = setTimeout(function () { hs = null; if (nqStarted) nqVidQ.add(nqNear(vp0, vids), -1); }, 120); }, { passive: true });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.preload = 'auto'; v.play().catch(function () {}); } else { v.pause(); } });
    }, { root: null, threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
    function nqAuto(el,speed,onDragStart){var pos=null,paused=false,idle=null,drag=null,moved=0,hover=false;
        function half(){return el.scrollWidth/2;}
        function norm(){var h=half();if(!h)return;if(el.scrollLeft>=h){el.scrollLeft-=h;pos=el.scrollLeft;}else if(el.scrollLeft<0){el.scrollLeft+=h;pos=el.scrollLeft;}}
        var last=null;function step(ts){if(last===null)last=ts;var dt=Math.min(.05,(ts-last)/1000);last=ts;if(!paused&&!hover&&!drag&&!document.hidden){if(pos===null)pos=el.scrollLeft;pos+=speed*dt;el.scrollLeft=pos;if(el.scrollLeft>=half()){pos-=half();el.scrollLeft=pos;}}requestAnimationFrame(step);}
        function pause(){paused=true;pos=null;clearTimeout(idle);idle=setTimeout(function(){paused=false;pos=null;norm();},3000);}
        el.addEventListener('dragstart',function(e){e.preventDefault();});el.addEventListener('wheel',pause,{passive:true});el.addEventListener('touchstart',pause,{passive:true});el.addEventListener('touchmove',pause,{passive:true});
        el.addEventListener('scroll',function(){if(paused||drag)norm();},{passive:true});
        el.addEventListener('mouseenter',function(){hover=true;});el.addEventListener('mouseleave',function(){hover=false;pos=null;});
        el.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;drag={x:e.clientX,s:el.scrollLeft};moved=0;pause();});
        window.addEventListener('pointermove',function(e){if(!drag)return;var dx=e.clientX-drag.x;moved=Math.max(moved,Math.abs(dx));el.scrollLeft=drag.s-dx;},{passive:true});
        window.addEventListener('pointerup',function(){if(drag){drag=null;pos=null;if(moved>6&&onDragStart)onDragStart();}});
        requestAnimationFrame(step);}
    var vp=root.querySelector('.nq-cmty__viewport');if(vp&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches)nqAuto(vp,window.innerWidth<900?28:40,null);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nq-crosssell"] && !Shopify.designMode) return;
  try {
    (function () {
    function nqCartUrl(a){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return (r+'cart/'+a+'.js').replace('//','/');}
    function initXsell(slider) {
      var track = slider.querySelector('[data-xs-track]');
      var prev = slider.querySelector('[data-xs-prev]');
      var next = slider.querySelector('[data-xs-next]');
      if (!track) return;
      function step() {
        var c = track.querySelector('.nqc-card');
        return c ? (c.offsetWidth + 30) : 320;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 2);
        if (next) next.toggleAttribute('disabled', track.scrollLeft >= max);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() {
      document.querySelectorAll('[data-xs-slider]').forEach(function (s) {
        if (s.dataset.xsBound) return;
        s.dataset.xsBound = '1';
        initXsell(s);
      });
    }
    initAll();
    document.addEventListener('shopify:section:load', initAll);

    /* Quick-add (2026-09-15) — mirrors snippets/nq-cart-drawer.liquid's own xsell "+ Add" so both
       surfaces stamp the same shape of _upsell_src and read identically in upsell_stats.py. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nq-xs-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-nq-xs-add');
      if (!vid) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';
      var slot = btn.getAttribute('data-nq-slot') || '';
      var anchor = btn.getAttribute('data-nq-anchor') || '';
      fetch(nqCartUrl('add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1,
          properties: { '_upsell_src': 'pdp|' + slot + '|' + anchor, '_upsell_v': 'v4' } }] })
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          btn.textContent = (window.__nqXsL && window.__nqXsL.added) || 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
